import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import "./Nav.css";
import A2movies from "./assets/A2movies.png";

const Nav = () => {
  const [show, handleshadow] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        handleshadow(true);
      } else {
        handleshadow(false);
      }
      return () => {
        window.removeEventListener("scroll");
      };
    });
  }, []);
  return (
    <div className={`nav ${show && "nav__black"} `}>
      <img className="nav__logo" alt="Netflix logo" src={A2movies} />
      <img
        className="nav__avatar"
        alt="Netflix smiley face"
        src="https://mir-s3-cdn-cf.behance.net/project_modules/disp/366be133850498.56ba69ac36858.png"
      />
    </div>
  );
};

export default Nav;
